import { render, staticRenderFns } from "./susu.vue?vue&type=template&id=f35fc230&"
import script from "./susu.vue?vue&type=script&lang=js&"
export * from "./susu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports